import { OnDestroy, Injectable, inject } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { WjFlexChart } from '@grapecity/wijmo.angular2.chart'
import { Subscription } from 'rxjs'
import { faSearch } from '@fortawesome/free-solid-svg-icons'

import { Services } from './services'
import { INameKeyed } from './interfaces'
import { Dictionary } from './utility/dictionary'

@Injectable()
export abstract class BaseComponent implements OnDestroy {
    protected faSearch = faSearch

    protected services = inject(Services)

    ngOnDestroy() {
        this.clearAllRequests()
    }

    public defaultId = '11111111-1111-1111-1111-111111111111'

    public isInitialLoading = true
    protected initialLoadingComplete() {
        this.isInitialLoading = false

        // this fixes issues with wijmo charts being hidden and not sized correctly
        setTimeout(() => {
            WjFlexChart.invalidateAll()
        }, 0)
    }

    protected setInitialSelection(
        activatedRoute: ActivatedRoute,
        queryParam: string,
        items: INameKeyed[],
        defaultId: string | null = null,
    ) {
        const urlParam = this.services.angular.getQueryParam(queryParam, activatedRoute).toLowerCase()
        let foundItem: undefined | INameKeyed = undefined

        if (urlParam != '') {
            foundItem = items.find(x => {
                if (typeof x.id === 'string') {
                    return x.id.toLowerCase() == urlParam
                } else {
                    return x.id.toString() == urlParam
                }
            })
        }

        if (foundItem == null && defaultId != null) {
            defaultId = defaultId.toLowerCase()
            foundItem = items.find(x => {
                if (typeof x.id === 'string') {
                    return x.id.toLowerCase() == defaultId
                } else {
                    return x.id.toString() == defaultId
                }
            })
        }

        if (foundItem == null && items.length > 0) {
            foundItem = items[0]
        }

        return foundItem
    }

    private httpRequestsById = new Dictionary<Subscription[]>()
    private clearAllRequests() {
        this.httpRequestsById.keys().forEach(key => {
            const requestsById = this.httpRequestsById.get(key, undefined)
            if (requestsById != null) {
                requestsById.forEach(x => {
                    x.unsubscribe()
                })

                requestsById.clearArray()
            }
        })
    }
    protected cancelableRequest(trackId: string, clearPreviousRequestsById: boolean, httpSubscription: Subscription) {
        let requestsById = this.httpRequestsById.get(trackId, undefined)
        if (requestsById == null) {
            requestsById = []
            this.httpRequestsById.add(trackId, requestsById)
        } else if (clearPreviousRequestsById) {
            requestsById.forEach(x => {
                x.unsubscribe()
            })

            requestsById.clearArray()
        }

        httpSubscription.add(() => {
            if (requestsById !== undefined) {
                requestsById.remove(httpSubscription)
            }
        })

        requestsById.push(httpSubscription)
    }
}
